import { useEffect, useMemo, useState } from 'react';
import { useRewardful } from './useRewardful';

export function useRewardfulData() {
  const { rewardful } = useRewardful();
  const [data, setData] = useState<Window['Rewardful']>();

  useEffect(() => {
    if (typeof data === 'undefined') {
      // Ensure rewardful has loaded
      rewardful?.('ready', () => {
        setData(() => window.Rewardful);
      });
    }
  }, [data, rewardful]);

  return useMemo(() => {
    if (data) {
      // Narrow Rewardful data from Data | undefined | false to Data | undefined
      return {
        affiliate: data.affiliate || undefined,
        coupon: data.coupon || undefined,
        referral: data.referral || undefined,
      };
    }
  }, [data]);
}
